import { globalGet, upload, post, get, put } from './request';

export async function fetchUserStatus(
  { userService },
  authenticationToken,
  { userID },
) {
  const url = `${userService}/trueprodigy/user/${userID}/status`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateUserStatus(
  { userService },
  authenticationToken,
  { userID, payload },
) {
  const url = `${userService}/trueprodigy/user/${userID}/status`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchUsers({ userService }, authenticationToken) {
  const url = `${userService}/trueprodigy/userlisting`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchOffices({ userService }) {
  const url = `${userService}/trueprodigy/officelisting`;
  const { body } = await get(null, url);
  return body;
}

export async function fetchLastRecalcStatus(
  { recalculationService },
  authenticationToken,
) {
  const url = `${recalculationService}/recalc/lastmassrecalcstatus`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getGeoCode(
  baseUrl,
  authenticationToken,
  { address, key },
) {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?&key=${key}&address=${encodeURI(
    address,
  )}`;
  const { body } = await globalGet(url);
  return body;
}

export async function startSpaceOcr(
  baseUrl,
  authenticationToken,
  { base64Image },
) {
  const url = 'https://api.ocr.space/parse/image';
  const formData = new FormData();
  formData.append('apikey', '03a08e29e988957');
  formData.append('base64Image', base64Image);
  const { body } = await upload(undefined, url, formData);
  return body;
}

export async function startGoogleOcr(
  baseUrl,
  authenticationToken,
  { base64Image },
) {
  const url =
    'https://vision.googleapis.com/v1/images:annotate?key=AIzaSyADvdDX4oRdhM4fMQRlVtWCjUDm5lAqCvw';
  const { body } = await post(
    undefined,
    url,
    {
      requests: [
        {
          image: {
            content: base64Image,
          },
          features: [
            {
              type: 'TEXT_DETECTION',
            },
          ],
        },
      ],
    },
    {
      noExposeHeaders: ['Content-Length', 'Content-Range', 'Content-Encoding'],
    },
  );
  return body;
}
